import { render, staticRenderFns } from "./EmailTemplatesList.vue?vue&type=template&id=9a9a25f0&"
import script from "./EmailTemplatesList.vue?vue&type=script&lang=js&"
export * from "./EmailTemplatesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports